import { useMutation } from "@tanstack/react-query";
import { useRef } from "react";
import { useQueryClient } from "@tanstack/react-query";

import { SEO_SLUG_CACHE_KEYS } from "./keys";

import { SeoSlugRepository } from "@/repositories/seo-slug";

export const useDeleteSeoSlug = () => {
  const seoSlugRepository = useRef(new SeoSlugRepository());
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id: string) => {
      return seoSlugRepository.current.delete(id);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SEO_SLUG_CACHE_KEYS.LIST, {}],
      });
    },
  });
};
